import {BrandBase} from '../BrandBase';
import {createMicrositeTheme} from '../MicrositeTheme';

export const bgmiBase: BrandBase = {
  id: `bgmi`,
  domain: `bgmichat.com`,
  email: `support@bgmi.in`,
  theme: `gaming`,
  backgroundId: `gaming`,
  adsenseId: null,
  micrositeTheme: createMicrositeTheme({
    id: `bgmi`,
    name: `BGMI Microsite`,
    palette: {
      primary: `#e55a00`,
      secondary: `#ff7a18`,
      accent: `#ffd056`,
    },
    gradients: {
      hero: `linear-gradient(135deg, #ff7a18, #e55a00)`,
      sectionLight: `linear-gradient(135deg, rgba(255, 244, 234, 0.97), rgba(255, 250, 240, 0.92))`,
      sectionDark: `linear-gradient(160deg, #140600, #2a0d00 50%, #0b0200 90%)`,
      primaryCta: `linear-gradient(120deg, #ff7a18, #ffae00 55%, #ffd056 100%)`,
    },
    ctas: {
      primary: {
        background: `linear-gradient(120deg, #ff7a18, #ffae00 55%, #ffd056 100%)`,
        glow: `rgba(255, 122, 24, 0.45)`,
        shadow: `0 32px 70px rgba(255, 122, 24, 0.4)`,
      },
    },
  }),
  manifest: {
    name: `BGMI Chat - Battlegrounds Mobile India Community | Gaming Chat Rooms`,
    short_name: `BGMI Chat`,
    description: `BGMI community chat rooms, gaming discussions, PUBG Mobile India chat. Connect with BGMI players, share stylish names, strategies, and game updates.`,
    theme_color: `#e55a00`,
    background_color: `#ffffff`,
    display: `standalone`,
    orientation: `portrait`,
    scope: `/`,
    start_url: `/`,
    icons: [],
  },
  canonical: {
    prod: `https://chat.bgmi.in`,
    uat: `https://chat-dev.bgmi.in`,
    local: `http://localhost:5173`,
    localdev: `http://localhost:5173`,
    localnative: `http://localhost:5173`,
  },
  hostRedirects: {
    'www.chat.bgmi.in': `chat.bgmi.in`,
  },
  favicon: `/logo-square.png`,
  seo: {
    keywords: `BGMI chat, battlegrounds mobile india, BGMI community, gaming chat, BGMI name generator, bgmi stylish name, bgmi name style, pubg mobile chat, gaming community, bgmi players, bgmi nickname, bgmi font generator, bgmi symbols, bgmi name style copy paste, best name for bgmi, bgmi unique name, bgmi gaming chat, mobile gaming community, find bgmi teammates, bgmi team finder, bgmi squad chat, join bgmi team, bgmi clan chat, gaming teammates finder, bgmi live chat, real time gaming chat, instant team chat, bgmi voice chat, gaming group chat, bgmi social platform, connect bgmi players, bgmi friends finder, gaming social network, bgmi community hub, bgmi duo partner, bgmi squad members, 4 player team bgmi, bgmi ranked team, bgmi custom room chat`,
    author: `BGMI Chat Community`,
  },
  social: {
    title: `BGMI Chat - Join the Ultimate Battlegrounds Mobile India Community`,
    image: `/icon.png`,
  },
};
